import type { ZikrSetId } from '@sayfazkari/content';
import { currentSetByClock } from '../lib/time';
import { readThemeToken, syncTelegramChrome } from '../telegram/chrome';

export type ThemeName = 'morning' | 'evening';
export type ThemeMode = 'auto' | ThemeName;

/**
 * В режиме auto тема следует набору, который человек читает,
 * а на главной — часам. Внутри сессии важнее контекст чтения:
 * вечерние азкары должны выглядеть вечерними, даже если открыты днём.
 */
export function resolveTheme(
  mode: ThemeMode,
  activeSet: ZikrSetId | null,
): ThemeName {
  if (mode !== 'auto') return mode;
  if (activeSet) return activeSet;
  return currentSetByClock();
}

export function applyTheme(theme: ThemeName): void {
  document.documentElement.dataset.theme = theme;
  // Цвет читается уже после смены data-theme, иначе прилетит старый
  const bg = readThemeToken('--c-bg');

  // Анти-флеш-скрипт в index.html ставит фон инлайновым стилем на <html>,
  // и этот стиль перебивает любые CSS-правила. Не обновить его здесь —
  // значит оставить фон прошлой темы навсегда: он вылезет при оверскролле
  // и в областях, которые .app не закрывает.
  document.documentElement.style.backgroundColor = bg;

  syncTelegramChrome(bg);
}
